module.exports = __webpack_public_path__ + "static/img/A88.93593416.jpg";